import ic from 'assets/icons/stacked-line-chart.svg';
import React, {Component, PureComponent} from 'react';
import {Bar, BarChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import './RarocBar.style.scss';

export default class RarocBar extends Component {
  render() {
    const data = [
      {name: 'Retail', previous: 22.5, current: 22.2},
      {name: 'Wholesale', previous: 20.23, current: 21.45},
      {name: 'Digital banking', previous: 25.5, current: 26.2},
      {name: 'Treasury', previous: 26.7, current: 26.5},
    ];
    return (
      <div className='raroc-bar-container'>
        <h1 className='title'>
          <img src={ic} alt='' style={{marginRight: 8}} />
          RAROC (**)
        </h1>
        <ResponsiveContainer width='100%' height={180}>
          <BarChart data={data} margin={{top: 16}}>
            <Tooltip cursor={false} content={<CustomTooltip />} />
            <XAxis dataKey='name' axisLine={false} tickLine={false} tick={<CustomizedAxisTick />} />
            <YAxis axisLine={false} tickLine={false} unit='%' />
            <Bar dataKey='current' fill='#FBC83A' width={68} radius={8} />
            <Bar dataKey='previous' fill='#EBEBEB' width={68} radius={8} />
            <Legend
              wrapperStyle={{
                paddingTop: '16px',
              }}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

class CustomizedAxisTick extends PureComponent {
  render() {
    const {x, y, payload} = this.props;

    return (
      <text x={x} y={y} dy={24} fill='#0B0B0A' textAnchor='middle' fontSize={14}>
        <tspan>{payload.value}</tspan>
      </text>
    );
  }
}
const CustomTooltip = (props) => {
  const {active, payload} = props;

  if (active && payload && payload.length) {
    const item = payload[0].payload;

    return (
      <div className='custom-tooltip'>
        <div className='name'>{item.name}</div>
        <div className='item'>
          <div className='color' style={{backgroundColor: '#fbc83a'}} />
          <div className='desc'>{item.current}%</div>
        </div>
        <div className='item'>
          <div className='color' style={{backgroundColor: '#EBEBEB'}} />
          <div className='desc'>{item.previous}%</div>
        </div>
      </div>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/RarocBar/RarocBar.js